export default function LargestVerifiedSection() {
  return (
    <section className="largest-verified-section">
      <div className="w-full flex justify-center">
        <div className="w-full max-w-[1020px] pt-32 pb-40 px-9 flex flex-col gap-12 md:gap-14 justify-center items-center">
          <h1 className="max-w-[548px] text-center text-[32px] md:text-[56px] leading-[32px] md:leading-[58px] text-[#0D2A4C] tracking-tighter font-semibold">
            The Largest Verified B2B Database Online
          </h1>
          <div className="grid grid-cols-2 gap-8 md:grid-cols-4 w-full">
            <div className="flex flex-col gap-3 items-center">
              <p className="font-semibold text-[42px] leading-8 md:text-7xl md:leading-[58px] text-[#0D2A4C] tracking-tighter">
                GDPR
              </p>
              <p className="font-medium text-sm text-center leading-[17px] md:text-[16px] md:leading-4 tracking-tight text-[#0D2A4C99]">
                Compliant
              </p>
            </div>
            <div className="flex flex-col gap-3 items-center">
              <p className="font-semibold text-[42px] leading-8 md:text-7xl md:leading-[58px] text-[#0D2A4C] tracking-tighter">
                5M
              </p>
              <p className="font-medium text-sm text-center leading-[17px] md:text-[16px] md:leading-4 tracking-tight text-[#0D2A4C99]">
                Emails verified monthly
              </p>
            </div>
            <div className="flex flex-col gap-3 items-center">
              <p className="font-semibold text-[42px] leading-8 md:text-7xl md:leading-[58px] text-[#0D2A4C] tracking-tighter">
                710M
              </p>
              <p className="font-medium text-sm text-center leading-[17px] md:text-[16px] md:leading-4 tracking-tight text-[#0D2A4C99]">
                Triple-Verified email contacts
              </p>
            </div>
            <div className="flex flex-col gap-3 items-center">
              <p className="font-semibold text-[42px] leading-8 md:text-7xl md:leading-[58px] text-[#0D2A4C] tracking-tighter">
                21B
              </p>
              <p className="font-medium text-sm text-center leading-[17px] md:text-[16px] md:leading-4 tracking-tight text-[#0D2A4C99]">
                Daily buying signals
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
